var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      !_vm.hideData && !_vm.orderRemoved
        ? _c("div", { staticClass: "container  pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-8 pt-md-4 " }, [
                _c("h3", { staticClass: "Regular text-left h0 widthFull" }, [
                  _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code))])
                ]),
                _vm._v(" "),
                _c("h5", { staticClass: "Regular h0 widthFull" }, [
                  _vm._v(
                    "Per redigere e inviare la Pratica ENEA abbiamo necessità di ulteriori informazioni"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "black mt-0 widthFull" }, [
                  _vm._v(
                    "\n          Completa il form qui sotto.\n          I dati inseriti verranno poi utilizzati per inviare la pratica Enea.\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 pt-md-4 mt-3 center mb-3 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary m-2 btn-sm btnRed ml-md-5",
                      attrs: { to: { name: "pratiche" } }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "arrow-left", size: "1x" }
                      }),
                      _vm._v("\n          Indietro\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "pb-5 pt-4  black vaillantCont widthFull",
                attrs: { id: "registration-form" }
              },
              [
                _c(
                  "div",
                  { staticClass: "row justify-content-center " },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm.item.client_type == "Persona fisica"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 mb-3",
                              staticStyle: { opacity: "1" }
                            },
                            [
                              _c("div", { staticClass: "group custInput" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.client_ownership,
                                        expression: "client_ownership"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          max: 63,
                                          min: 2
                                        },
                                        expression:
                                          "{required:true, max: 63, min: 2}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "client_ownership"
                                      ),
                                      valid: !!_vm.client_ownership
                                    },
                                    attrs: {
                                      type: "text",
                                      autocomplete: "randomq",
                                      id: "client_ownership",
                                      name: "client_ownership",
                                      "data-vv-as": "Titolo di possesso"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.client_ownership = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "Proprietario" } },
                                      [_vm._v("Proprietario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Usufruttuario" } },
                                      [_vm._v("Usufruttuario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Locatario" } },
                                      [_vm._v("Locatario/Comodatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Locatario" } },
                                      [_vm._v("Comodatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Promissario acquirente"
                                        }
                                      },
                                      [_vm._v("Promissario acquirente")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Familiare convivente del possessore/detentore"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Familiare convivente del possessore/detentore"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Erede" } },
                                      [_vm._v("Erede")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Coniuge separato assegnatario"
                                        }
                                      },
                                      [_vm._v("Coniuge separato assegnatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà indivisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà indivisa"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà divisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà divisa"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "client_ownership" }
                                  },
                                  [_vm._v("Titolo di possesso *")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("client_ownership")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "client_ownership"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row justify-content-center pb-5 " }, [
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.house_surface,
                            expression: "house_surface"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 8, min: 1 },
                            expression: "{required:true, max: 8, min: 1}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("house_surface"),
                          valid: !!_vm.house_surface
                        },
                        attrs: {
                          type: "number",
                          id: "house_surface",
                          name: "house_surface",
                          "data-vv-as": "Superficie utile in m2"
                        },
                        domProps: { value: _vm.house_surface },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.house_surface = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _vm.errors.has("house_surface")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.first("house_surface")) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-5" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.house_count,
                            expression: "house_count"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 8, min: 1 },
                            expression: "{required:true, max: 8, min: 1}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("house_count"),
                          valid: !!_vm.house_count
                        },
                        attrs: {
                          type: "number",
                          id: "house_count",
                          name: "house_count",
                          "data-vv-as":
                            "Numero unità immobiliari che compongono l'edificio"
                        },
                        domProps: { value: _vm.house_count },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.house_count = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "house_count" }
                        },
                        [
                          _vm._v(
                            "Num. unità immob. che compongono l'edificio * "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("house_count")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.first("house_count")) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-4 mb-3",
                      staticStyle: { opacity: "1" }
                    },
                    [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.house_work_on,
                                expression: "house_work_on"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 163, min: 2 },
                                expression: "{required:true, max: 163, min: 2}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("house_work_on"),
                              valid: !!_vm.house_work_on
                            },
                            attrs: {
                              type: "text",
                              autocomplete: "randomq",
                              id: "house_work_on",
                              name: "house_work_on",
                              "data-vv-as": "intevento su"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.house_work_on = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "Singola unità immobliare in un edificio costituito da più unità immobliari"
                                }
                              },
                              [
                                _vm._v(
                                  "Singola unità immobliare in un edificio costituito da più unità immobliari"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "Edificio costitutito da una singola unità immobiliare"
                                }
                              },
                              [
                                _vm._v(
                                  "Edificio costitutito da una singola unità immobiliare"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Parti comuni condominiali" } },
                              [_vm._v("Parti comuni condominiali")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "Intero edifico o qualsiasi altro edifico non incluso nei casi sopra riportati"
                                }
                              },
                              [
                                _vm._v(
                                  "Intero edifico o qualsiasi altro edifico non incluso nei casi sopra riportati"
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "house_work_on" }
                          },
                          [_vm._v("intevento su *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("house_work_on")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errors.first("house_work_on")) +
                                  "\n            "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-4 mb-3",
                      staticStyle: { opacity: "1" }
                    },
                    [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.building_type,
                                expression: "building_type"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 163, min: 2 },
                                expression: "{required:true, max: 163, min: 2}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("building_type"),
                              valid: !!_vm.building_type
                            },
                            attrs: {
                              type: "text",
                              autocomplete: "randomq",
                              id: "building_type",
                              name: "building_type",
                              "data-vv-as": "Tipologia dell`edificio"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.building_type = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "Edificio in linea e condominio oltre i tre piani fuori terra"
                                }
                              },
                              [
                                _vm._v(
                                  "Edificio in linea e condominio oltre i tre piani fuori terra"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "Edificio a schiera e condominio fino a tre piani"
                                }
                              },
                              [
                                _vm._v(
                                  "Edificio a schiera e condominio fino a tre piani"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "costruzione isolata (es. mono o plurifamiliare)"
                                }
                              },
                              [
                                _vm._v(
                                  "Costruzione isolata (es. mono o plurifamiliare)"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "Edificio industriale, artigianale o commerciale"
                                }
                              },
                              [
                                _vm._v(
                                  "Edificio industriale, artigianale o commerciale"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "altro (specificare)" } },
                              [_vm._v("altro (specificare)")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "building_type" }
                          },
                          [_vm._v("Tipologia dell`edificio *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("building_type")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errors.first("building_type")) +
                                  "\n            "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.building_type == "altro (specificare)"
                    ? _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.building_type_other,
                                expression: "building_type_other"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 128, min: 3 },
                                expression: "{required:true, max: 128, min: 3}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has(
                                "building_type_other"
                              ),
                              valid: !!_vm.building_type_other
                            },
                            attrs: {
                              type: "text",
                              id: "building_type_other",
                              name: "building_type_other",
                              "data-vv-as": "Tipologia di impianto sostituito"
                            },
                            domProps: { value: _vm.building_type_other },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.building_type_other = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "building_type_other" }
                            },
                            [_vm._v("Tipologia dell`edificio * ")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("building_type_other")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.errors.first("building_type_other")
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.building_year,
                            expression: "building_year"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              max: 4,
                              min: 4,
                              max_value: _vm.moment().format("Y"),
                              min_value: 1800
                            },
                            expression:
                              "{required:true, max: 4, min: 4, max_value: moment().format('Y'), min_value: 1800}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("building_year"),
                          valid: !!_vm.building_year
                        },
                        attrs: {
                          type: "number",
                          id: "building_year",
                          name: "building_year",
                          "data-vv-as": "Anno di costruzione (anche se stimato)"
                        },
                        domProps: { value: _vm.building_year },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.building_year = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _vm.errors.has("building_year")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.first("building_year")) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-4 mb-3",
                      staticStyle: { opacity: "1" }
                    },
                    [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.building_merged,
                                expression: "building_merged"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 163, min: 2 },
                                expression: "{required:true, max: 163, min: 2}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("building_merged"),
                              valid: !!_vm.building_merged
                            },
                            attrs: {
                              type: "text",
                              autocomplete: "randomq",
                              id: "building_merged",
                              name: "building_merged",
                              "data-vv-as": "accorpamenti di unità immobiliari"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.building_merged = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "SI" } }, [
                              _vm._v("SI")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "NO" } }, [
                              _vm._v("NO")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _vm._m(3),
                        _vm._v(" "),
                        _vm.errors.has("building_merged")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errors.first("building_merged")) +
                                  "\n            "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.item.bonus != "Bonus Casa 50%" &&
                (_vm.has_condensazione ||
                  _vm.has_tradizionale ||
                  _vm.has_pompadicalore ||
                  _vm.has_ibridi ||
                  _vm.has_scaldacqua ||
                  _vm.has_climatizzatore)
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.type_system_old,
                                      expression: "type_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "type_system_old"
                                    ),
                                    valid: !!_vm.type_system_old
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "type_system_old",
                                    name: "type_system_old",
                                    "data-vv-as": "Tipo di impianto sostituito"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.type_system_old = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "Impianto autonomo" } },
                                    [_vm._v("Impianto autonomo")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "Impianto centralizzato "
                                      }
                                    },
                                    [_vm._v("Impianto centralizzato ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "Impianto centralizzato con contabilizzazione di calore per singolo utente"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Impianto centralizzato con contabilizzazione di calore per singolo utente"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "Impianto centralizzato con più generatori di calore"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Impianto centralizzato con più generatori di calore"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "Impianto centralizzato con più generatori di calore e contabilizzazione per singolo utente "
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Impianto centralizzato con più generatori di calore e contabilizzazione per singolo utente "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "altro" } }, [
                                    _vm._v("altro")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "type_system_old" }
                                },
                                [_vm._v("Tipo di impianto sostituito *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("type_system_old")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first("type_system_old")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.count_system_old,
                                  expression: "count_system_old"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 8, min: 1 },
                                  expression: "{required:true, max: 8, min: 1}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "count_system_old"
                                ),
                                valid: !!_vm.count_system_old
                              },
                              attrs: {
                                type: "number",
                                id: "count_system_old",
                                name: "count_system_old",
                                "data-vv-as": "Numero di impianti sostituiti"
                              },
                              domProps: { value: _vm.count_system_old },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.count_system_old = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "count_system_old" }
                              },
                              [_vm._v("Numero di impianti sostituiti * ")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("count_system_old")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first("count_system_old")
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.group_system_old,
                                      expression: "group_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "group_system_old"
                                    ),
                                    valid: !!_vm.group_system_old
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "group_system_old",
                                    name: "group_system_old",
                                    "data-vv-as":
                                      "Tipologia di impianto sostituito"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.group_system_old = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "caldaia ad acqua standard"
                                      }
                                    },
                                    [_vm._v("caldaia ad acqua standard")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "caldaia ad acqua calda a bassa temperatura"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "caldaia ad acqua calda a bassa temperatura"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "caldaia a gas a condensazione"
                                      }
                                    },
                                    [_vm._v("caldaia a gas a condensazione")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "caldaia a gasolio a condensazione"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "caldaia a gasolio a condensazione"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "Pompa di calore/Impianto Geotermico"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Pompa di calore/Impianto Geotermico"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: { value: "Generatore aria calda" }
                                    },
                                    [_vm._v("Generatore aria calda")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "Scambiatore per teleriscaldamento"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Scambiatore per teleriscaldamento"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Caldaia a Biomassa" } },
                                    [_vm._v("Caldaia a Biomassa")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "altro (specificare)" } },
                                    [_vm._v("altro (specificare)")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "group_system_old" }
                                },
                                [_vm._v("Tipologia di impianto sostituito *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("group_system_old")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first("group_system_old")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.group_system_old == "altro (specificare)"
                          ? _c("div", { staticClass: "col-md-12" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.group_system_old_other,
                                      expression: "group_system_old_other"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 128,
                                        min: 3
                                      },
                                      expression:
                                        "{required:true, max: 128, min: 3}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "group_system_old_other"
                                    ),
                                    valid: !!_vm.group_system_old_other
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "group_system_old_other",
                                    name: "group_system_old_other",
                                    "data-vv-as":
                                      "Tipologia di impianto sostituito"
                                  },
                                  domProps: {
                                    value: _vm.group_system_old_other
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.group_system_old_other =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "group_system_old_other" }
                                  },
                                  [
                                    _vm._v(
                                      "Tipologia di impianto sostituito * "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("group_system_old_other")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "group_system_old_other"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.potenza_utile_system_old,
                                  expression: "potenza_utile_system_old"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 8, min: 1 },
                                  expression: "{required:true, max: 8, min: 1}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "potenza_utile_system_old"
                                ),
                                valid: !!_vm.potenza_utile_system_old
                              },
                              attrs: {
                                type: "number",
                                id: "potenza_utile_system_old",
                                name: "potenza_utile_system_old",
                                "data-vv-as":
                                  "Potenza utile nominale del impianto sostituito (KW)"
                              },
                              domProps: { value: _vm.potenza_utile_system_old },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.potenza_utile_system_old =
                                    $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "potenza_utile_system_old" }
                              },
                              [_vm._v("Potenza utile nominale (KW) * ")]
                            ),
                            _vm._v(" "),
                            _c("small", [
                              _vm._v(" del impianto sostituito   ")
                            ]),
                            _vm._v(" "),
                            _vm.errors.has("potenza_utile_system_old")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "potenza_utile_system_old"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.rendimento_100_system_old,
                                  expression: "rendimento_100_system_old"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    max: 4,
                                    min: 1,
                                    max_value: 100
                                  },
                                  expression:
                                    "{required:true, max: 4, min: 1, max_value: 100 }"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "rendimento_100_system_old"
                                ),
                                valid: !!_vm.rendimento_100_system_old
                              },
                              attrs: {
                                type: "number",
                                id: "rendimento_100_system_old",
                                name: "rendimento_100_system_old",
                                "data-vv-as": "Rendimento al 100% della potenza"
                              },
                              domProps: {
                                value: _vm.rendimento_100_system_old
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.rendimento_100_system_old =
                                    $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "rendimento_100_system_old" }
                              },
                              [_vm._v("Rendimento al 100% * ")]
                            ),
                            _vm._v(" "),
                            _vm.group_system_old ==
                              "caldaia ad acqua standard" ||
                            _vm.group_system_old ==
                              "caldaia a gas a condensazione"
                              ? _c("small", [
                                  _vm._v(
                                    " rendimento nelle condizioni di temperatura di mandata e ritorno rispettivamente di 80°C e 60°C  "
                                  )
                                ])
                              : _vm.group_system_old ==
                                "Pompa di calore/Impianto Geotermico"
                              ? _c("small", [
                                  _vm._v(
                                    " la potenza elettrica assorbita (kW)  "
                                  )
                                ])
                              : _c("small", [_vm._v(" della potenza  ")]),
                            _vm._v(" "),
                            _vm.errors.has("rendimento_100_system_old")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "rendimento_100_system_old"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.vettore_termico_system_old,
                                      expression: "vettore_termico_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "vettore_termico_system_old"
                                    ),
                                    valid: !!_vm.vettore_termico_system_old
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "vettore_termico_system_old",
                                    name: "vettore_termico_system_old",
                                    "data-vv-as":
                                      "Vettore termico prevalentemente utilizzato"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.vettore_termico_system_old = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "Gas metano" } },
                                    [_vm._v("Gas metano")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Gasolio" } },
                                    [_vm._v("Gasolio")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Gpl" } }, [
                                    _vm._v("Gpl")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Teleriscaldamento" } },
                                    [_vm._v("Teleriscaldamento")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Olio combustibile" } },
                                    [_vm._v("Olio combustibile")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Energia elettrica" } },
                                    [_vm._v("Energia elettrica")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Biomassa" } },
                                    [_vm._v("Biomassa")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Altro" } }, [
                                    _vm._v("Altro")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "vettore_termico_system_old" }
                                },
                                [_vm._v("Vettore termico *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("vettore_termico_system_old")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "vettore_termico_system_old"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(" prevalentemente utilizzato  ")
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(5)
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.has_solare
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.solare_inclinazione,
                                  expression: "solare_inclinazione"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 8, min: 1 },
                                  expression: "{required:true, max: 8, min: 1}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "solare_inclinazione"
                                ),
                                valid: !!_vm.solare_inclinazione
                              },
                              attrs: {
                                type: "number",
                                id: "solare_inclinazione",
                                name: "solare_inclinazione",
                                "data-vv-as": "Inclinazione"
                              },
                              domProps: { value: _vm.solare_inclinazione },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.solare_inclinazione = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "solare_inclinazione" }
                              },
                              [_vm._v("Inclinazione % * ")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("solare_inclinazione")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first("solare_inclinazione")
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.solare_orientamento,
                                      expression: "solare_orientamento"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "solare_orientamento"
                                    ),
                                    valid: !!_vm.solare_orientamento
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "solare_orientamento",
                                    name: "solare_orientamento",
                                    "data-vv-as": "Orientamento"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.solare_orientamento = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "nord" } }, [
                                    _vm._v("nord")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "nord-est" } },
                                    [_vm._v("nord-est")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "est" } }, [
                                    _vm._v("est")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "sud-est" } },
                                    [_vm._v("sud-est")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "ovest" } }, [
                                    _vm._v("ovest")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "nord-ovest" } },
                                    [_vm._v("nord-ovest")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "p-orizzontale" } },
                                    [_vm._v("p-orizzontale")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "solare_orientamento" }
                                },
                                [_vm._v("Orientamento *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("solare_orientamento")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "solare_orientamento"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.solare_tipo_impianto_sostituito,
                                      expression:
                                        "solare_tipo_impianto_sostituito"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "solare_tipo_impianto_sostituito"
                                    ),
                                    valid: !!_vm.solare_tipo_impianto_sostituito
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "solare_tipo_impianto_sostituito",
                                    name: "solare_tipo_impianto_sostituito",
                                    "data-vv-as":
                                      "Tipo di impianto integrato o sostituito"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.solare_tipo_impianto_sostituito = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "Boiler elettrico" } },
                                    [_vm._v("Boiler elettrico")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "Scaldacqua a Gas o Gasolio"
                                      }
                                    },
                                    [_vm._v("Scaldacqua a Gas o Gasolio")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Altro" } }, [
                                    _vm._v("Altro")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Nessuno" } },
                                    [_vm._v("Nessuno")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: {
                                    for: "solare_tipo_impianto_sostituito"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Tipo di impianto integrato o sostituito *"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("solare_tipo_impianto_sostituito")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "solare_tipo_impianto_sostituito"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.has_condensazione
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _vm._m(7),
                        _vm._v(" "),
                        _vm.item.bonus == "Bonus Casa 50%"
                          ? _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.potenza_utile_system_old,
                                      expression: "potenza_utile_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true, max: 8, min: 1 },
                                      expression:
                                        "{required:true, max: 8, min: 1}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "potenza_utile_system_old"
                                    ),
                                    valid: !!_vm.potenza_utile_system_old
                                  },
                                  attrs: {
                                    type: "number",
                                    id: "potenza_utile_system_old",
                                    name: "potenza_utile_system_old",
                                    "data-vv-as":
                                      "Potenza utile nominale del impianto sostituito (KW)"
                                  },
                                  domProps: {
                                    value: _vm.potenza_utile_system_old
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.potenza_utile_system_old =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "potenza_utile_system_old" }
                                  },
                                  [_vm._v("Potenza utile nominale (KW) * ")]
                                ),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(" del impianto sostituito   ")
                                ]),
                                _vm._v(" "),
                                _vm.errors.has("potenza_utile_system_old")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "potenza_utile_system_old"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.condensazione_caldaia_destinata_a,
                                      expression:
                                        "condensazione_caldaia_destinata_a"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "condensazione_caldaia_destinata_a"
                                    ),
                                    valid: !!_vm.condensazione_caldaia_destinata_a
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "condensazione_caldaia_destinata_a",
                                    name: "condensazione_caldaia_destinata_a",
                                    "data-vv-as": "Caldaia destinata a"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.condensazione_caldaia_destinata_a = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: { value: "Riscaldamento Ambiente" }
                                    },
                                    [_vm._v("Riscaldamento Ambiente")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "Riscaldamento Ambiente + Produzione ACS"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Riscaldamento Ambiente + Produzione ACS"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.item.bonus != "Bonus Casa 50%"
                                    ? _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "Solo produzione di ACS centralizzata"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Solo produzione di ACS centralizzata"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: {
                                    for: "condensazione_caldaia_destinata_a"
                                  }
                                },
                                [_vm._v("Caldaia destinata a *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has(
                                "condensazione_caldaia_destinata_a"
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "condensazione_caldaia_destinata_a"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.condensazione_alimentazione_caldaia,
                                      expression:
                                        "condensazione_alimentazione_caldaia"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "condensazione_alimentazione_caldaia"
                                    ),
                                    valid: !!_vm.condensazione_alimentazione_caldaia
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "condensazione_alimentazione_caldaia",
                                    name: "condensazione_alimentazione_caldaia",
                                    "data-vv-as": "Alimentazione Caldaia"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.condensazione_alimentazione_caldaia = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "Gas Naturale" } },
                                    [_vm._v("Gas Naturale")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Gpl" } }, [
                                    _vm._v("Gpl")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Gasolio" } },
                                    [_vm._v("Gasolio")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: {
                                    for: "condensazione_alimentazione_caldaia"
                                  }
                                },
                                [_vm._v("Alimentazione Caldaia *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has(
                                "condensazione_alimentazione_caldaia"
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "condensazione_alimentazione_caldaia"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.item.bonus != "Bonus Casa 50%"
                          ? _c(
                              "div",
                              {
                                staticClass: "col-md-4 mb-3",
                                staticStyle: { opacity: "1" }
                              },
                              [
                                _c("div", { staticClass: "group custInput" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.condensazione_present_clima,
                                          expression:
                                            "condensazione_present_clima"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            max: 163,
                                            min: 2
                                          },
                                          expression:
                                            "{required:true, max: 163, min: 2}"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "condensazione_present_clima"
                                        ),
                                        valid: !!_vm.condensazione_present_clima
                                      },
                                      attrs: {
                                        type: "text",
                                        autocomplete: "randomq",
                                        id: "condensazione_present_clima",
                                        name: "condensazione_present_clima",
                                        "data-vv-as":
                                          "Presenza dell’impianto di climatizzazione estivo"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.condensazione_present_clima = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "SI" } }, [
                                        _vm._v("SI")
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "NO" } }, [
                                        _vm._v("NO")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _vm._m(8),
                                  _vm._v(" "),
                                  _vm.errors.has("condensazione_present_clima")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "condensazione_present_clima"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.has_pompadicalore || _vm.has_scaldacqua
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _vm._m(9),
                        _vm._v(" "),
                        _vm.item.bonus == "Bonus Casa 50%"
                          ? _c(
                              "div",
                              {
                                staticClass: "col-md-4 mb-3",
                                staticStyle: { opacity: "1" }
                              },
                              [
                                _c("div", { staticClass: "group custInput" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.group_system_old,
                                          expression: "group_system_old"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            max: 163,
                                            min: 2
                                          },
                                          expression:
                                            "{required:true, max: 163, min: 2}"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "group_system_old"
                                        ),
                                        valid: !!_vm.group_system_old
                                      },
                                      attrs: {
                                        type: "text",
                                        autocomplete: "randomq",
                                        id: "group_system_old",
                                        name: "group_system_old",
                                        "data-vv-as":
                                          "Tipologia di impianto sostituito"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.group_system_old = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "caldaia ad acqua standard"
                                          }
                                        },
                                        [_vm._v("caldaia ad acqua standard")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "caldaia ad acqua calda a bassa temperatura"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "caldaia ad acqua calda a bassa temperatura"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "caldaia a gas a condensazione"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "caldaia a gas a condensazione"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "caldaia a gasolio a condensazione"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "caldaia a gasolio a condensazione"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "Pompa di calore/Impianto Geotermico"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Pompa di calore/Impianto Geotermico"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "Generatore aria calda"
                                          }
                                        },
                                        [_vm._v("Generatore aria calda")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "Scambiatore per teleriscaldamento"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Scambiatore per teleriscaldamento"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: { value: "Caldaia a Biomassa" }
                                        },
                                        [_vm._v("Caldaia a Biomassa")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "altro" } },
                                        [_vm._v("altro")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "Nessuno" } },
                                        [_vm._v("Nessuno")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "group_system_old" }
                                    },
                                    [
                                      _vm._v(
                                        "Tipologia di impianto sostituito *"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("group_system_old")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "group_system_old"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.bonus == "Bonus Casa 50%"
                          ? _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.potenza_utile_system_old,
                                      expression: "potenza_utile_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true, max: 8, min: 1 },
                                      expression:
                                        "{required:true, max: 8, min: 1}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "potenza_utile_system_old"
                                    ),
                                    valid: !!_vm.potenza_utile_system_old
                                  },
                                  attrs: {
                                    type: "number",
                                    id: "potenza_utile_system_old",
                                    name: "potenza_utile_system_old",
                                    "data-vv-as":
                                      "Potenza utile nominale del impianto sostituito (KW)"
                                  },
                                  domProps: {
                                    value: _vm.potenza_utile_system_old
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.potenza_utile_system_old =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _vm.group_system_old !=
                                "Pompa di calore/Impianto Geotermico"
                                  ? _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: {
                                          for: "potenza_utile_system_old"
                                        }
                                      },
                                      [_vm._v("Potenza utile nominale (KW) * ")]
                                    )
                                  : _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: {
                                          for: "potenza_utile_system_old"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "la potenza elettrica assorbita (kW) * "
                                        )
                                      ]
                                    ),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(" del impianto sostituito   ")
                                ]),
                                _vm._v(" "),
                                _vm.errors.has("potenza_utile_system_old")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "potenza_utile_system_old"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.pdc_superficie_utile_riscaldata,
                                  expression: "pdc_superficie_utile_riscaldata"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 8, min: 1 },
                                  expression: "{required:true, max: 8, min: 1}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "pdc_superficie_utile_riscaldata"
                                ),
                                valid: !!_vm.pdc_superficie_utile_riscaldata
                              },
                              attrs: {
                                type: "number",
                                id: "pdc_superficie_utile_riscaldata",
                                name: "pdc_superficie_utile_riscaldata",
                                "data-vv-as":
                                  "Superficie utile riscaldata dalla PDC (m2)"
                              },
                              domProps: {
                                value: _vm.pdc_superficie_utile_riscaldata
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.pdc_superficie_utile_riscaldata =
                                    $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: {
                                  for: "pdc_superficie_utile_riscaldata"
                                }
                              },
                              [_vm._v("Superficie utile riscaldata (m2) * ")]
                            ),
                            _vm._v(" "),
                            _c("small", [_vm._v(" dalla PDC  ")]),
                            _vm._v(" "),
                            _vm.errors.has("pdc_superficie_utile_riscaldata")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "pdc_superficie_utile_riscaldata"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.has_climatizzatore
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.pdc_superficie_utile_riscaldata,
                                  expression: "pdc_superficie_utile_riscaldata"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 8, min: 1 },
                                  expression: "{required:true, max: 8, min: 1}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "pdc_superficie_utile_riscaldata"
                                ),
                                valid: !!_vm.pdc_superficie_utile_riscaldata
                              },
                              attrs: {
                                type: "number",
                                id: "pdc_superficie_utile_riscaldata",
                                name: "pdc_superficie_utile_riscaldata",
                                "data-vv-as":
                                  "Superficie utile riscaldata dalla PDC (m2)"
                              },
                              domProps: {
                                value: _vm.pdc_superficie_utile_riscaldata
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.pdc_superficie_utile_riscaldata =
                                    $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: {
                                  for: "pdc_superficie_utile_riscaldata"
                                }
                              },
                              [_vm._v("Superficie utile riscaldata (m2) * ")]
                            ),
                            _vm._v(" "),
                            _c("small", [_vm._v(" ( o raffreddata )  ")]),
                            _vm._v(" "),
                            _vm.errors.has("pdc_superficie_utile_riscaldata")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "pdc_superficie_utile_riscaldata"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.item.bonus == "Bonus Casa 50%"
                          ? _c(
                              "div",
                              {
                                staticClass: "col-md-4 mb-3",
                                staticStyle: { opacity: "1" }
                              },
                              [
                                _c("div", { staticClass: "group custInput" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.group_system_old,
                                          expression: "group_system_old"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            max: 163,
                                            min: 2
                                          },
                                          expression:
                                            "{required:true, max: 163, min: 2}"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "group_system_old"
                                        ),
                                        valid: !!_vm.group_system_old
                                      },
                                      attrs: {
                                        type: "text",
                                        autocomplete: "randomq",
                                        id: "group_system_old",
                                        name: "group_system_old",
                                        "data-vv-as":
                                          "Tipologia di impianto sostituito"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.group_system_old = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "caldaia ad acqua standard"
                                          }
                                        },
                                        [_vm._v("caldaia ad acqua standard")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "caldaia ad acqua calda a bassa temperatura"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "caldaia ad acqua calda a bassa temperatura"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "caldaia a gas a condensazione"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "caldaia a gas a condensazione"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "caldaia a gasolio a condensazione"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "caldaia a gasolio a condensazione"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "Pompa di calore/Impianto Geotermico"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Pompa di calore/Impianto Geotermico"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "Generatore aria calda"
                                          }
                                        },
                                        [_vm._v("Generatore aria calda")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "Scambiatore per teleriscaldamento"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Scambiatore per teleriscaldamento"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: { value: "Caldaia a Biomassa" }
                                        },
                                        [_vm._v("Caldaia a Biomassa")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "altro" } },
                                        [_vm._v("altro")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "Nessuno" } },
                                        [_vm._v("Nessuno")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "group_system_old" }
                                    },
                                    [
                                      _vm._v(
                                        "Tipologia di impianto sostituito *"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("group_system_old")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "group_system_old"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.bonus == "Bonus Casa 50%"
                          ? _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.potenza_utile_system_old,
                                      expression: "potenza_utile_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true, max: 8, min: 1 },
                                      expression:
                                        "{required:true, max: 8, min: 1}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "potenza_utile_system_old"
                                    ),
                                    valid: !!_vm.potenza_utile_system_old
                                  },
                                  attrs: {
                                    type: "number",
                                    id: "potenza_utile_system_old",
                                    name: "potenza_utile_system_old",
                                    "data-vv-as":
                                      "Potenza utile nominale del impianto sostituito (KW)"
                                  },
                                  domProps: {
                                    value: _vm.potenza_utile_system_old
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.potenza_utile_system_old =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _vm.group_system_old !=
                                "Pompa di calore/Impianto Geotermico"
                                  ? _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: {
                                          for: "potenza_utile_system_old"
                                        }
                                      },
                                      [_vm._v("Potenza utile nominale (KW) * ")]
                                    )
                                  : _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: {
                                          for: "potenza_utile_system_old"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "la potenza elettrica assorbita (kW) * "
                                        )
                                      ]
                                    ),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v("* del impianto sostituito   ")
                                ]),
                                _vm._v(" "),
                                _vm.errors.has("potenza_utile_system_old")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "potenza_utile_system_old"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.has_ibridi
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _vm._m(10),
                        _vm._v(" "),
                        _vm.item.bonus == "Bonus Casa 50%"
                          ? _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.potenza_utile_system_old,
                                      expression: "potenza_utile_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true, max: 8, min: 1 },
                                      expression:
                                        "{required:true, max: 8, min: 1}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "potenza_utile_system_old"
                                    ),
                                    valid: !!_vm.potenza_utile_system_old
                                  },
                                  attrs: {
                                    type: "number",
                                    id: "potenza_utile_system_old",
                                    name: "potenza_utile_system_old",
                                    "data-vv-as":
                                      "Potenza utile nominale del impianto sostituito (KW)"
                                  },
                                  domProps: {
                                    value: _vm.potenza_utile_system_old
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.potenza_utile_system_old =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "potenza_utile_system_old" }
                                  },
                                  [_vm._v("Potenza utile nominale (KW) * ")]
                                ),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(" del impianto sostituito   ")
                                ]),
                                _vm._v(" "),
                                _vm.errors.has("potenza_utile_system_old")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "potenza_utile_system_old"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.ibrido_alimentazione_caldaia,
                                      expression: "ibrido_alimentazione_caldaia"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "ibrido_alimentazione_caldaia"
                                    ),
                                    valid: !!_vm.ibrido_alimentazione_caldaia
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "ibrido_alimentazione_caldaia",
                                    name: "ibrido_alimentazione_caldaia",
                                    "data-vv-as": "Alimentazione Caldaia"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.ibrido_alimentazione_caldaia = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "Gas Naturale" } },
                                    [_vm._v("Gas Naturale")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Gpl" } }, [
                                    _vm._v("Gpl")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Gasolio" } },
                                    [_vm._v("Gasolio")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "ibrido_alimentazione_caldaia" }
                                },
                                [_vm._v("Alimentazione Caldaia *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("ibrido_alimentazione_caldaia")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "ibrido_alimentazione_caldaia"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row justify-content-center pb-5 " },
                  [
                    _vm.item.client_type == "Partita IVA"
                      ? [
                          _c("div", { staticClass: "col-md-12" }, [
                            _vm.item.client_type == "Partita IVA"
                              ? _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [
                                    _vm._v(
                                      "\n              Completa i dati del cliente finale ("
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.item.client_name) +
                                          " " +
                                          _vm._s(_vm.item.client_lastname)
                                      )
                                    ]),
                                    _vm._v(")\n            ")
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.azienda,
                                    expression: "azienda"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 128, min: 3 },
                                    expression:
                                      "{required:true, max: 128, min: 3}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("azienda"),
                                  valid: !!_vm.azienda
                                },
                                attrs: {
                                  type: "text",
                                  id: "azienda",
                                  name: "azienda",
                                  "data-vv-as": "Ragione sociale"
                                },
                                domProps: { value: _vm.azienda },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.azienda = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "azienda" }
                                },
                                [_vm._v("Ragione sociale * ")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("azienda")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("azienda")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.partita_iva,
                                    expression: "partita_iva"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      partitaIva: true,
                                      max: 11,
                                      min: 11
                                    },
                                    expression:
                                      "{required: true, partitaIva: true, max: 11, min: 11,}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("partita_iva"),
                                  valid: !!_vm.partita_iva
                                },
                                attrs: {
                                  type: "text",
                                  id: "partita_iva",
                                  name: "partita_iva",
                                  "data-vv-as": "Partita IVA"
                                },
                                domProps: { value: _vm.partita_iva },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.partita_iva = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "partita_iva" }
                                },
                                [_vm._v("Partita IVA *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("partita_iva")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.errors.first("partita_iva")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 mb-3",
                              staticStyle: { opacity: "1" }
                            },
                            [
                              _c("div", { staticClass: "group custInput" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.client_ownership,
                                        expression: "client_ownership"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          max: 63,
                                          min: 2
                                        },
                                        expression:
                                          "{required:true, max: 63, min: 2}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "client_ownership"
                                      ),
                                      valid: !!_vm.client_ownership
                                    },
                                    attrs: {
                                      type: "text",
                                      autocomplete: "randomq",
                                      id: "client_ownership",
                                      name: "client_ownership",
                                      "data-vv-as": "Titolo di possesso"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.client_ownership = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "Proprietario" } },
                                      [_vm._v("Proprietario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Usufruttuario" } },
                                      [_vm._v("Usufruttuario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Locatario" } },
                                      [_vm._v("Locatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Promissario acquirente"
                                        }
                                      },
                                      [_vm._v("Promissario acquirente")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Familiare convivente del possessore/detentore"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Familiare convivente del possessore/detentore"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Erede" } },
                                      [_vm._v("Erede")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Coniuge separato assegnatario"
                                        }
                                      },
                                      [_vm._v("Coniuge separato assegnatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà indivisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà indivisa"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà divisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà divisa"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "client_ownership" }
                                  },
                                  [_vm._v("Titolo di possesso *")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("client_ownership")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "client_ownership"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("h4", { staticClass: "widthFull center black" }, [
                            _vm._v("\n            Sede Legale\n          ")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.address,
                                    expression: "address"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 128, min: 5 },
                                    expression:
                                      "{required:true, max: 128, min: 5}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("address"),
                                  valid: !!_vm.address
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomr",
                                  id: "address",
                                  name: "address",
                                  "data-vv-as": "Indirizzo"
                                },
                                domProps: { value: _vm.address },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.address = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "address" }
                                },
                                [_vm._v("Indirizzo *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("address")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("address")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.civic,
                                    expression: "civic"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 15 },
                                    expression: "{required:true, max: 15}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("civic"),
                                  valid: !!_vm.civic
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomt",
                                  id: "civic",
                                  name: "civic",
                                  "data-vv-as": "N. Civico"
                                },
                                domProps: { value: _vm.civic },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.civic = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "civic" }
                                },
                                [_vm._v("N. Civico *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("civic")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("civic")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.cap,
                                    expression: "cap"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, min: 5, max: 6 },
                                    expression:
                                      "{required:true, min: 5, max: 6}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("cap"),
                                  valid: !!_vm.cap
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomt",
                                  id: "cap",
                                  name: "cap",
                                  "data-vv-as": "CAP"
                                },
                                domProps: { value: _vm.cap },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.cap = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "cap" }
                                },
                                [_vm._v("CAP *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("cap")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("cap")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.client_type == "Amministratore di condominio"
                      ? [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "h4",
                              { staticClass: "widthFull center black" },
                              [
                                _vm._v(
                                  "\n              Completa i dati dell'Amministratore del condominio ("
                                ),
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.item.client_name) +
                                      " " +
                                      _vm._s(_vm.item.client_lastname)
                                  )
                                ]),
                                _vm._v(")\n            ")
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.quantHouses,
                                    expression: "quantHouses"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, min: 1, max: 6 },
                                    expression:
                                      "{required:true, min: 1, max: 6}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("quantHouses"),
                                  valid: !!_vm.quantHouses
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomt",
                                  id: "quantHouses",
                                  name: "quantHouses",
                                  "data-vv-as": "Numero di unità immobiliari"
                                },
                                domProps: { value: _vm.quantHouses },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.quantHouses = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "quantHouses" }
                                },
                                [
                                  _vm._v(
                                    "Numero di unità immobiliari che compongono l’edificio *"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("quantHouses")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.errors.first("quantHouses")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(11),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3 " }, [
                      _c(
                        "div",
                        { staticClass: "group custInput" },
                        [
                          _c("datepicker", {
                            attrs: {
                              language: _vm.it,
                              "full-month-name": true,
                              format: "dd MMMM yyyy",
                              "monday-first": true,
                              id: "eventStartdate",
                              name: "eventStartdate",
                              "input-class": "form-control dateInput"
                            },
                            model: {
                              value: _vm.eventStartdate,
                              callback: function($$v) {
                                _vm.eventStartdate = $$v
                              },
                              expression: "eventStartdate"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.eventStartdate,
                                expression: "eventStartdate"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{required:true}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("eventStartdate"),
                              valid: !!_vm.eventStartdate
                            },
                            attrs: {
                              type: "text",
                              id: "eventStartdate",
                              name: "eventStartdate",
                              "data-vv-as": "Data inizio"
                            },
                            domProps: { value: _vm.eventStartdate },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.eventStartdate = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "eventStartdate" }
                            },
                            [_vm._v("Data inizio")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("eventStartdate")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("eventStartdate")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3 " }, [
                      _c(
                        "div",
                        { staticClass: "group custInput" },
                        [
                          _c("datepicker", {
                            attrs: {
                              language: _vm.it,
                              "full-month-name": true,
                              format: "dd MMMM yyyy",
                              "monday-first": true,
                              disabledDates: _vm.disabledDatesStart,
                              id: "eventEndtdate",
                              name: "eventEndtdate",
                              "input-class": "form-control dateInput"
                            },
                            model: {
                              value: _vm.eventEndtdate,
                              callback: function($$v) {
                                _vm.eventEndtdate = $$v
                              },
                              expression: "eventEndtdate"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.eventEndtdate,
                                expression: "eventEndtdate"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{required:true}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("eventEndtdate"),
                              valid: !!_vm.eventEndtdate
                            },
                            attrs: {
                              type: "text",
                              id: "eventEndtdate",
                              name: "eventEndtdate",
                              "data-vv-as": "Data ultimazione dei lavori"
                            },
                            domProps: { value: _vm.eventEndtdate },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.eventEndtdate = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "eventEndtdate" }
                            },
                            [_vm._v("Data ultimazione dei lavori (collaudo)")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("eventEndtdate")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("eventEndtdate")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.item.bonus != "Bonus Casa 50%"
                      ? [
                          _vm._m(12),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-8 mb-3 pr-4 text-left" },
                            [
                              _c("div", { staticClass: "form-check" }, [
                                _c("div", { staticClass: "p-3" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.noValvole,
                                        expression: "noValvole"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {},
                                        expression: "{}"
                                      }
                                    ],
                                    staticClass: "form-check-input",
                                    class: {
                                      "is-invalid": _vm.errors.has("noValvole")
                                    },
                                    attrs: {
                                      type: "checkbox",
                                      id: "noValvole",
                                      name: "noValvole",
                                      "data-vv-as": ""
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.noValvole)
                                        ? _vm._i(_vm.noValvole, null) > -1
                                        : _vm.noValvole
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.noValvole,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.noValvole = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.noValvole = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.noValvole = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm._m(13),
                                  _vm._v(" "),
                                  _vm.errors.has("noValvole")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.errors.first("noValvole")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.noValvole
                            ? _c("div", { staticClass: "col-md-12 mb-4" }, [
                                _c("p", { staticClass: "center" }, [
                                  _vm._v(
                                    "Se necessario è possibile selezionare piu di un file"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "front-image" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          size: 10240,
                                          ext: ["jpeg", "jpg", "png", "pdf"],
                                          mimes: [
                                            "image/jpeg",
                                            "image/jpg",
                                            "image/png",
                                            "application/pdf"
                                          ]
                                        },
                                        expression:
                                          "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                      }
                                    ],
                                    ref: "fileInput",
                                    staticClass: "fileInput",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "invoiceFront"
                                      ),
                                      valid: !!_vm.invoiceFront,
                                      helper: !!_vm.invoiceFrontBucket
                                    },
                                    attrs: {
                                      type: "file",
                                      multiple: "",
                                      name: "invoiceFront",
                                      id: "invoiceFront",
                                      "data-vv-as":
                                        "Scheda tecnica delle valvole termostatiche"
                                    },
                                    on: { change: _vm.uploadFile }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "niceInputLabel labelFileInput",
                                      attrs: { for: "invoiceFront" }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "smallText center white",
                                              style: {
                                                backgroundImage:
                                                  "url(" +
                                                  _vm.invoiceFrontBucket +
                                                  ")"
                                              }
                                            },
                                            [
                                              !_vm.invoiceFrontName
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "smallText center white mt-3 mb-0 pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Scegli il Contratto quadro*"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _c("span", {
                                            staticClass:
                                              "smallText center white",
                                            style: {
                                              backgroundImage:
                                                "url(" +
                                                _vm.invoiceFrontBucket +
                                                ")"
                                            }
                                          })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("invoiceFront")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "invalid-feedback",
                                          staticStyle: { top: "185px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.errors.first("invoiceFront")
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.uploadFrontPercentage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "progress mt-5",
                                          attrs: { id: "progFront" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "progress-bar ",
                                              style: {
                                                width:
                                                  _vm.uploadFrontPercentage +
                                                  "%"
                                              },
                                              attrs: {
                                                id: "progress-bar-front",
                                                role: "progressbar",
                                                "aria-valuenow": "50",
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.uploadFrontPercentage
                                                  ) +
                                                  " %\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.invoiceFrontName
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                        },
                                        [_vm._v(_vm._s(_vm.invoiceFrontName))]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 mb-3 center mt-5" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btnRed",
                          attrs: { type: "button" },
                          on: { click: _vm.setAditionalEneaData }
                        },
                        [_vm._v(" Salva ")]
                      )
                    ])
                  ],
                  2
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v("\n            Inserisci i dati dell'immobile\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "niceInputLabel", attrs: { for: "house_surface" } },
      [_vm._v("Superficie utile in m"), _c("sup", [_vm._v("2")]), _vm._v(" * ")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "niceInputLabel", attrs: { for: "building_year" } },
      [
        _vm._v("Anno di costruzione "),
        _c("small", [_vm._v("(anche se stimato)")]),
        _vm._v(" * ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "niceInputLabel", attrs: { for: "building_merged" } },
      [
        _c("small", [
          _vm._v("Si sono verificati degli accorpamenti di unità immobiliari?")
        ]),
        _vm._v(" *")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\n            Inserisci i dati dell'impianto termico sostituito\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-11 center" }, [
      _c("p", { staticClass: "center mb-0 small" }, [
        _vm._v(
          "\n          Nel caso di più generatori dello stesso tipo indicare la somma delle potenze e il valore medio pesato rispetto alla potenza nominale del rendimento.\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "center mb-0 small " }, [
        _vm._v(
          "\n          Per le pompe di calore indicare la potenza elettrica assorbita e la potenza utile nelle condizioni nominali indicate nell’Allegato I del decreto 10/02/2007 come modificato dal DM 06/08/2009.\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "center mb-0 small" }, [
        _vm._v(
          "\n          Per le caldaia ad acqua inserire il rendimento nelle condizioni di temperatura di mandata e ritorno rispettivamente di 80 °C e 60 °C.\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v("\n            Inserisci i dati del Solare termico\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\n            Inserisci i dati della Caldaia a condensazione\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "niceInputLabel",
        attrs: { for: "condensazione_present_clima" }
      },
      [
        _c("small", [
          _vm._v("Presenza dell’impianto di climatizzazione estivo?")
        ]),
        _vm._v(" *")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\n            Inserisci i dati della Pompa di calore\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\n            Inserisci i dati della Sistema Ibrido\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v("\n            Inserisci i dati dell'intervento\n          ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "center " }, [
        _vm._v(
          "\n            Sulla piattaforma entro 75 giorni dalla chiusura dei lavori o dal collaudo delle opere in modo da permetterci di rispettare, nella gestione, il termine ultimo di 90 giorni dalla chiusura dei lavori o dal collaudo delle opere previsto dalla legge.\n          "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "center red" }, [
        _vm._v(
          "\n            Se i dati per la compilazione della dichiarazione non vengono comunicati nei tempi richiesti per legge non possiamo prendere in carico la gestione della dichiarazione Enea.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\n              Scheda tecnica delle valvole termostatiche\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "form-check-label textStable",
        attrs: { for: "noValvole" }
      },
      [
        _c("b", [
          _vm._v(
            "Valvole termostatiche non installate come da relazione allegata alla Dichiarazione di Conformità.\n                  "
          ),
          _c("br"),
          _vm._v(
            "Se questo campo viene valorizzato il documento richiesto può essere omesso."
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5414bf37", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5414bf37","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/complateEneaData/index.vue
// module id = null
// module chunks = 